<script>
  import { scrollTo } from "../../../library/function/browser";
  import Link from "./Link.svelte";
  export let fab_item = {};
  export let classNames = "";

  // Variables.
  const element = document.querySelector(fab_item.link);

  // Handle click.
  function handle_click(e) {
    jQuery(document).ready(function () {
      let scrollDuration = fab_item.extraOptions.scroll_duration;
      let anchorTopPadding = 30;
      let position = jQuery(fab_item.link).offset().top;
      position = position >= anchorTopPadding ? position - anchorTopPadding : position;
      scrollTo(document.documentElement, position, scrollDuration);
    });
  }
</script>

{#if element}
  <Link {fab_item} {classNames} on:click={handle_click} />
{/if}
